import { Download as DownloadIcon } from 'lucide-react';
import React from 'react';
import { useI18n } from '../../i18n/I18nProvider';
import { AMAZON_URL } from '../../lib/constants';

const Content: React.FC = () => {
  const { t } = useI18n();

  return (
    <section id='content' className='bg-gradient-to-br from-gray-50 to-white'>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-16 py-12 px-6 max-w-7xl mx-auto'>
        {/* Columna izquierda: texto */}
        <div className='flex flex-col justify-center'>
          <h2 className='text-3xl md:text-4xl font-bold text-gray-800 mb-4'>{t.content.title}</h2>
          <p className='text-lg text-gray-700 mb-4 leading-relaxed'>{t.content.description}</p>
          <p className='text-lg text-gray-600 mb-6 leading-relaxed italic'>{t.content.purpose}</p>
          <ul className='space-y-2 text-gray-700'>
            {t.content.features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>
        {/* Columna derecha: caja de compra */}
        <div className='p-6 flex flex-col items-center justify-center'>
          <a
            href={AMAZON_URL}
            target='_blank'
            rel='noopener noreferrer'
            className='bg-gradient-to-r from-orange-500 to-yellow-400 hover:from-orange-600 hover:to-yellow-500 text-white font-semibold py-4 px-10 rounded-lg shadow text-center transition flex items-center justify-center gap-3 text-xl mb-8'
          >
            <DownloadIcon className='h-6 w-6' />
            {t.content.submitButton}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Content;
